<div id="email-dialog">
  <form [formGroup]="emailDialogForm">
    <div id="email-dialog-form">
      <div class="no-padding form-inputs">
        <div class="input-row">
          <div class="label">
            {{ 'ADMIN.LABEL.EMAIL_TO_GROUP' | translate }}:
          </div>
          <div>
            <p-autoComplete
              [suggestions]="emailGroups"
              (completeMethod)="emailGroupSearch($event)"
              (onSelect)="groupSelected($event)"
              formControlName="groups"
              [dropdown]="true"
              optionLabel="name"
              appendTo="body"
            />
          </div>
        </div>

        <div class="input-row">
          <div class="label">
            {{ 'ADMIN.LABEL.EMAIL_TO_CONTACT' | translate }}:
          </div>
          <div>
            <p-autoComplete
              [suggestions]="contacts"
              (completeMethod)="contactSearch($event)"
              (onSelect)="contactSelected($event)"
              formControlName="contacts"
              optionLabel="fullName"
              [dropdown]="true"
              appendTo="body"
            />
          </div>
        </div>

        <div class="input-row">
          <div class="label">{{ 'ADMIN.LABEL.EMAIL_TO' | translate }}:</div>
          <div>
            <input type="text" pInputText formControlName="emailAddresses" />
          </div>

          <div style="margin-left: 8px">
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.ADD' | translate }}"
              icon="fa fa-fw fa-plus-circle"
              (click)="addEmailToList()"
            ></button>
          </div>
        </div>

        <div class="input-row-top-aligned">
          <div class="label">{{ 'ADMIN.LABEL.EMAIL_NOTES' | translate }}:</div>
          <div style="width: 75%">
            <textarea
              pTextarea
              style="width: 100%"
              formControlName="emailNotes"
              [rows]="5"
              [cols]="57"
            ></textarea>
          </div>
        </div>
      </div>

      @if (showEmailList()) {
        <div>
          <div class="header-label">
            {{ 'ADMIN.LABEL.EMAILING' | translate }}:
          </div>
          <div>
            <p-listbox
              formControlName="lsEmailList"
              [options]="emailList"
              (onChange)="itemSelected($event)"
              [listStyle]="{ 'max-height': '375px' }"
              optionLabel="name"
            />
          </div>
        </div>
      }
      <div class="no-padding" style="margin-top: 8px">
        <div class="button-wrapper" style="margin-left: 8px">
          <button
            pButton
            label="{{ sendLabel() | translate }}"
            icon="fa fa-fw fa-envelope"
            (click)="sendEmail()"
            [disabled]="this.emailList.length === 0"
            type="button"
          ></button>
        </div>
        @if (showEmailList()) {
          <div class="button-wrapper" style="margin-left: 8px">
            <button
              pButton
              label="{{ 'COMMON.LABEL.BUTTONS.REMOVE' | translate }}"
              icon="fa fa-fw fa-minus-circle"
              (click)="removeListItem()"
            ></button>
          </div>
        }
      </div>
    </div>
  </form>
</div>
